module.exports = __webpack_public_path__ + "static/media/Background-1.b740e9d0.jpg";